import { APPSFLYER } from "../enums/appsflyer.enum.js";
 import { setupCustomParams } from "./mobile.lib.js";

class AppsFlyer {

    static load() {
        const container = document.querySelector('div.smart-banner');
        // Check mutation observer support (needed for callback when banner displayed)
        if (!container || !'MutationObserver' in window) {
            return;
        }

        const bannerObserver = new MutationObserver((mutations, observer) => {
            mutations.forEach((mutation) => {

                // Banner added
                if (mutation.addedNodes.length) {
                   setTimeout(() => {
                       mutation.target.classList.remove('hide');
                   }, 300);
                }

                // Banner removed
                else if (mutation.removedNodes.length) {
                   bannerObserver.disconnect();
                }
            });
        });

        bannerObserver.observe(container, {childList: true});

        window.addEventListener('scroll', AppsFlyer.inject);
        
    }

    static inject() {

        // Remove listener early
        window.removeEventListener('scroll', AppsFlyer.inject);
        
        const smartBannerId = APPSFLYER.smartBannerId;
        // Inject Smart Banner code with ID
        !function(t,e,n,s,a,c,i,o,p){t.AppsFlyerSdkObject=a,t.AF=t.AF||function(){(t.AF.q=t.AF.q||[]).push([Date.now()].concat(Array.prototype.slice.call(arguments)))},t.AF.id=t.AF.id||i,t.AF.plugins={},o=e.createElement(n),p=e.getElementsByTagName(n)[0],o.async=1,o.src="https://websdk.appsflyer.com?"+(c.length>0?"st="+c.split(",").sort().join(",")+"&":"")+(i.length>0?"af_id="+i:""),p.parentNode.insertBefore(o,p)}(window,document,"script",0,"AF","banners",{banners: {key: smartBannerId}});

        // Show smart banner with attribution params
        AF('banners', 'showBanner', {
            bannerContainerQuery: "div.smart-banner",
            additionalParams: setupCustomParams()
        });
        
    }

}

export default AppsFlyer;